import React from "react";
import { WarningAmber } from "@mui/icons-material";
import { Box, Paper, Stack, Typography } from "@mui/material";

interface SEOSuggestionsCardProps {
  suggestions: string[];
}

const SEOSuggestionsCard: React.FC<SEOSuggestionsCardProps> = ({ suggestions }) => {
  if (!suggestions.length) return null;

  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <WarningAmber color="warning" fontSize="small" />
        <Typography fontWeight={800}>Suggestions</Typography>
      </Box>
      <Stack spacing={1} component="ul" sx={{ m: 0, pl: 2.5 }}>
        {suggestions.map((suggestion) => (
          <Typography key={suggestion} component="li" variant="body2" color="text.secondary">
            {suggestion}
          </Typography>
        ))}
      </Stack>
    </Paper>
  );
};

export default SEOSuggestionsCard;
